import { NgModule, NO_ERRORS_SCHEMA, LOCALE_ID } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { MDBBootstrapModule } from './typescripts/free';
import { MDBBootstrapModulePro } from './typescripts/pro';
import {ReactiveFormsModule} from '@angular/forms';
import { MDBSpinningPreloader } from './typescripts/pro/index';
import { ExcelService } from './excel.service';
import { CalendarModule } from 'angular-calendar';
import { AgmCoreModule } from '@agm/core';
import { ToastModule } from './typescripts/pro/alerts/toast/toast.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
//import { ColorPickerModule } from 'ngx-color-picker';
//import { NgxGalleryModule } from 'ngx-gallery';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import localeES from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { QuillModule } from 'ngx-quill'
import {MaterialModule} from './material/material.module';

import {CdkTableModule} from '@angular/cdk/table';
import { DataTablesModule } from 'angular-datatables';

import { LoginComponent } from './login/login.component';
import { CabeceraadminComponent } from './cabeceraadmin/cabeceraadmin.component';
import { AdminloginComponent } from './adminlogin/adminlogin.component';
import { AdminusersComponent } from './adminusers/adminusers.component';
import { AdmincolaboradoresComponent } from './admincolaboradores/admincolaboradores.component';
import { AdminextraescolaresComponent } from './adminextraescolares/adminextraescolares.component';
//import { AdmininscripcionesComponent } from './admininscripciones/admininscripciones.component';
import { AdminlandingComponent } from './adminlanding/adminlanding.component';
import { AdminayudaComponent } from './adminayuda/adminayuda.component';
import { AdminvideoayudaComponent } from './adminvideoayuda/adminvideoayuda.component';
import { AdminlistadosSociosComponent } from './adminlistados-socios/adminlistados-socios.component';
import { AdminlistadosUsuariosComponent } from './adminlistados-usuarios/adminlistados-usuarios.component';
import { AdminlistadosExtraescolaresComponent } from './adminlistados-extraescolares/adminlistados-extraescolares.component';
import { AdminlistadosEventosComponent } from './adminlistados-eventos/adminlistados-eventos.component';
import { AdmincontabilidadComponent } from './admincontabilidad/admincontabilidad.component';
import { AdmincolaboradoresCrearComponent } from './admincolaboradores-crear/admincolaboradores-crear.component';
//import { AdmingaleriaCrearComponent } from './admingaleria-crear/admingaleria-crear.component';
import { AdminextraescolaresCrearComponent } from './adminextraescolares-crear/adminextraescolares-crear.component';
import { AdminnoticiasComponent } from './adminnoticias/adminnoticias.component';
import { AdminnoticiasCrearComponent } from './adminnoticias-crear/adminnoticias-crear.component';
import { AdminextraescolaresGruposComponent } from './adminextraescolares-grupos/adminextraescolares-grupos.component';
import { AdminextraescolaresGruposCrearComponent } from './adminextraescolares-grupos-crear/adminextraescolares-grupos-crear.component';
import { AdmincentroescolarInformacionComponent } from './admincentro-escolar-informacion/admincentro-escolar-informacion.component';
import { AdmincentroEscolarInformacionCrearComponent } from './admincentro-escolar-informacion-crear/admincentro-escolar-informacion-crear.component';
import { AdmincentroescolarCursosComponent } from './admincentro-escolar-cursos/admincentro-escolar-cursos.component';
import { AdmincentroEscolarCursosCrearComponent } from './admincentro-escolar-cursos-crear/admincentro-escolar-cursos-crear.component';

import { AdmininscripcionesEventoCrearComponent } from './admininscripciones-evento-crear/admininscripciones-evento-crear.component';
import { AdminampaCuotasSociosComponent } from './adminampa-cuotas-socios/adminampa-cuotas-socios.component';
import { AdminampaInformacionComponent } from './adminampa-informacion/adminampa-informacion.component';
import { AdminempresasComponent } from './adminempresas/adminempresas.component';
import { AdminempresasCrearComponent } from './adminempresas-crear/adminempresas-crear.component';
import { AdminampaInformacionCrearComponent } from './adminampa-informacion-crear/adminampa-informacion-crear.component';
import { AdminlistadosUsuariosCrearComponent } from './adminlistados-usuarios-crear/adminlistados-usuarios-crear.component';
import { AdminlistadosSociosCrearComponent } from './adminlistados-socios-crear/adminlistados-socios-crear.component';
import { AdminlistadosExtraescolaresCrearComponent } from './adminlistados-extraescolares-crear/adminlistados-extraescolares-crear.component';

import { AppConfigService} from './app.config';
import { APP_INITIALIZER } from '@angular/core';
import {MyHttpService} from './services/MyHttpService'
import { routes } from './app.routes';
import {UsuarioService} from './services/usuarioService';

//importamos el servicio de las ampas
import {AmpaService} from './services/ampaService'
export function loadConfig(config: AppConfigService) {
  return () => config.load();
  //config.load();
  //return  config;
}



export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

registerLocaleData(localeES);


@NgModule({
  declarations: [
    AppComponent,
    AdminloginComponent,
    AdmincolaboradoresComponent,
    AdminextraescolaresComponent,
    //AdmininscripcionesComponent,
    //AdminlunchComponent,
    //AdminmodificarsociosComponent,
    //AdminnotificacionesComponent,
    AdminusersComponent,
    CabeceraadminComponent,
    LoginComponent,
    AdminlandingComponent,
    AdminayudaComponent,
    AdminvideoayudaComponent,
    //AdmindescargasComponent,
    AdminlistadosSociosComponent,
    AdminlistadosUsuariosComponent,
    AdminlistadosExtraescolaresComponent,
    AdminlistadosEventosComponent,
    //AdmingaleriaComponent,
    //AdmineventosCalendarioComponent,
    //AdmineventosValidacionesComponent,
    //AdminnotificacionesCrearComponent,
    AdmincontabilidadComponent,
    AdmincolaboradoresCrearComponent,
    //AdmingaleriaCrearComponent,
    AdminextraescolaresCrearComponent,
    AdminnoticiasComponent,
    AdminnoticiasCrearComponent,
    AdminextraescolaresGruposComponent,
    AdminextraescolaresGruposCrearComponent,
    AdminampaCuotasSociosComponent,
    AdminampaInformacionComponent,
    AdmincentroescolarInformacionComponent,
    AdmincentroescolarCursosComponent,
    AdmincentroEscolarCursosCrearComponent,

    AdmininscripcionesEventoCrearComponent,

    AdminampaCuotasSociosComponent,
    AdminampaInformacionComponent,
    AdmincentroEscolarCursosCrearComponent,
    AdmincentroEscolarInformacionCrearComponent,
    AdminempresasComponent,
    AdminempresasCrearComponent,
    AdminampaInformacionCrearComponent,
    AdminlistadosUsuariosCrearComponent,
    AdminlistadosSociosCrearComponent,
    AdminlistadosExtraescolaresCrearComponent,

  ],
  imports: [
    MaterialModule,
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
       TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
    QuillModule,
    CalendarModule.forRoot(),
    FormsModule,
    HttpModule,
    AgmCoreModule.forRoot({ apiKey: 'AIzaSyDjOMkp0ifbFEPM-AqeyMJCoMdtzKXBla4' }),
    ToastModule.forRoot(),
    MDBBootstrapModule.forRoot(),
    MDBBootstrapModulePro.forRoot(),
    //RouterModule.forRoot(ROUTES),
    //ColorPickerModule,
    //NgxGalleryModule,

   ReactiveFormsModule,
   CdkTableModule,
   DataTablesModule,
   routes



  ],
  providers: [MDBSpinningPreloader, ExcelService, HttpClient,
    //{ provide: LOCALE_ID, useValue: "es-ES" },
    AmpaService, AppConfigService, MyHttpService, UsuarioService,
    { provide: LOCALE_ID, useValue: "es-ES"},
    { provide: APP_INITIALIZER,
    useFactory: loadConfig,//(config: AppConfig) => () => config.load(),
    deps: [AppConfigService], multi: true }
  ],
  bootstrap: [AppComponent],
  schemas:      [ NO_ERRORS_SCHEMA ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts